import type { GlobalCommandMenuCopy } from './global-command-menu-copy';
import type { LinkScopeConfig } from './link-scopes';
import { isLinkScope, type LinkScope, type MenuPage } from './types';

type LinkConfigs = Record<LinkScope, LinkScopeConfig>;

export function menuPlaceholder(
  page: MenuPage,
  text: GlobalCommandMenuCopy,
  links: LinkConfigs
): string {
  switch (page.kind) {
    case 'scope':
      if (page.scope === 'products') return text.searchProducts;
      if (page.scope === 'threads') return text.searchThreads;
      if (page.scope === 'scheduled') return text.searchScheduled;
      if (isLinkScope(page.scope)) {
        return text.searchIn(links[page.scope].label);
      }
      return text.searchAll;
    case 'actions':
      return text.runCommand;
    case 'picker':
      return page.subPage.placeholder ?? text.searchAll;
    case 'root':
      return text.searchAll;
  }
}

export function menuBreadcrumb(
  page: MenuPage,
  text: GlobalCommandMenuCopy,
  links: LinkConfigs
): string | null {
  switch (page.kind) {
    case 'scope':
      if (isLinkScope(page.scope)) return links[page.scope].label;
      return {
        products: text.products,
        threads: text.threads,
        projects: text.projects,
        avatars: text.avatars,
        aesthetics: text.aesthetics,
        members: text.members,
        scheduled: text.scheduled,
      }[page.scope];
    case 'actions':
      return text.commands;
    case 'picker':
      return page.label;
    case 'root':
      return null;
  }
}
